import { useState } from "react";
import { Loader2 } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { cn } from "@/lib/cn";
import { IncomingOrdersMobileList } from "@/components/production/IncomingOrdersMobileList";
import { ProductionOrderDetailDialog } from "@/components/production/ProductionOrderDetailDialog";
import type { IncomingOrderRow } from "@/components/production/production-types";

const SITUACOES = [
  { chave: "todos", rotulo: "Todos", status: null },
  { chave: "aguardando", rotulo: "Aguardando aceite", status: ["AGUARDANDO_CONFIRMACAO"] },
  { chave: "producao", rotulo: "Em produção", status: ["ACEITO", "EM_PRODUCAO"] },
  { chave: "concluidos", rotulo: "Concluídos", status: ["CONCLUIDO"] },
  { chave: "encerrados", rotulo: "Cancelados e recusados", status: ["CANCELADO", "RECUSADO"] },
] as const;

/** Os pedidos deste cliente com o laboratório, com o mesmo detalhe do Pedidos. */
export function PedidosDoCadastro({ clientOrganizationId }: { clientOrganizationId: string }) {
  const consulta = trpc.prosthesis.incoming.list.useQuery({ clientOrganizationId });
  const [situacao, setSituacao] = useState<(typeof SITUACOES)[number]["chave"]>("todos");
  const [aberto, setAberto] = useState<string | null>(null);
  const pedidos = (consulta.data ?? []) as unknown as IncomingOrderRow[];
  const filtro = SITUACOES.find((s) => s.chave === situacao)!;
  const visiveis = filtro.status ? pedidos.filter((p) => (filtro.status as readonly string[]).includes(p.status)) : pedidos;
  const contar = (s: (typeof SITUACOES)[number]) => (s.status ? pedidos.filter((p) => (s.status as readonly string[]).includes(p.status)).length : pedidos.length);

  if (consulta.isLoading) {
    return (
      <div className="flex justify-center py-16">
        <Loader2 className="h-6 w-6 animate-spin text-brand-600" />
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-1.5">
        {SITUACOES.map((s) => (
          <button
            key={s.chave}
            type="button"
            aria-pressed={situacao === s.chave}
            onClick={() => setSituacao(s.chave)}
            className={cn(
              "h-8 rounded-md border px-3 text-xs font-medium",
              situacao === s.chave
                ? "border-brand-300 bg-brand-50 text-brand-700 dark:border-primary/40 dark:bg-primary/10 dark:text-primary"
                : "border-zinc-200 bg-white text-zinc-600 hover:border-brand-300 dark:border-border dark:bg-card dark:text-muted-foreground",
            )}
          >
            {s.rotulo} <span className="tabular-nums opacity-70">{contar(s)}</span>
          </button>
        ))}
      </div>
      {visiveis.length === 0 ? (
        <p className="rounded-xl border border-zinc-200 bg-white px-4 py-10 text-center text-sm text-zinc-500 dark:border-border dark:bg-card dark:text-muted-foreground">
          Nenhum pedido aqui.
        </p>
      ) : (
        <IncomingOrdersMobileList orders={visiveis} onViewDetail={(o) => setAberto(o.id)} />
      )}
      <ProductionOrderDetailDialog order={pedidos.find((p) => p.id === aberto) ?? null} onClose={() => setAberto(null)} />
    </div>
  );
}
